import axios from 'axios'

/** PUBLIC API **/
const publicApi = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_PROXIED_API_URL ?? process.env.NEXT_PUBLIC_API,
})

publicApi.interceptors.response.use(
  function (response) {
    return response.data
  },
  function (error) {
    return Promise.reject(error)
  },
)

export { publicApi }
